import { Button, ButtonGroup, Intent, Popover, Position, Size, Tooltip } from "@blueprintjs/core"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, ITableRow, LANDING_TYPE_CONTENT, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"
import { table } from "console"

/* Protopia Ecosystem component */
export interface ITableTrEditorProps {
   table: TableContent
   row: ITableRow
   i: number
   section: ILandingSection
   children: any
}
const TableTrEditor = (props: ITableTrEditorProps): JSX.Element => {
    const isEdit : boolean = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit )

    const onVisible = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    return {
                        ...props.table,
                        data: props.table.data.map((row, i) => {
                            if( i === props.i) {
                                return {
                                    ...row,
                                    isHidden: !row.isHidden
                                }
                            }
                            return row
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Change table row visible " 
        }
        updateSection( data, historyStep )
    }
    const onAddAfter = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    ((meat.data || []) as any[]).splice(
                        props.i + 1, 
                        0, 
                        {
                            id: getID(`row-${props.table.id}-`),
                            cells: Array( props.table.threads.cells.length ).fill("1").map(() => {
                                return { text: "" }
                            })
                        }
                        
                    ) 
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Add table's row" 
        }
        updateSection( data, historyStep )

    }
    const onRemove = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    ((meat.data || []) as any[]).splice(props.i, 1) 
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Remove table row" 
        }
        updateSection( data, historyStep )
    }

    return <>
        { props.children }
        {
            !!isEdit && <div className="landing-table-row-editor pe-surface pe-item-editor" data-select-type="ignore" >
                <ButtonGroup>
                    { 
                        props.i < props.table.data.length - 1
                            ?
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_LEFT}
                                content={<div className="">{__("Swap down")}</div>}
                            >
                                <Button
                                    className="edit-menu-btn"
                                    icon="chevron-down"
                                    size={ Size.SMALL }
                                />
                            </Tooltip>
                            :
                            <></>
                    }
                    {
                        props.i > 0
                            ?
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_LEFT}
                                content={<div className="">{__("Swap up")}</div>}
                            >
                                <Button
                                    className="edit-menu-btn"
                                    icon="chevron-up"
                                    size={ Size.SMALL }
                                />
                            </Tooltip>
                            :
                            <></>
                    } 
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__( props.row?.isHidden ? "Do show" : "Do hide" )}</div>}
                    >
                        <Button
                            className="edit-menu-btn"
                            icon={ !props.row?.isHidden ? "eye-open" : "eye-off"}
                            size={ Size.SMALL }
                            //text={__( props.row.isHidden ? "Do show" : "Do hide" )}
                            onClick={onVisible}
                        />
                    </Tooltip>
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__(  "Add after" )}</div>}
                    >
                        <Button
                            className="edit-menu-btn"
                            icon={ "plus" }
                            size={ Size.SMALL }
                            //text={__( "Add after" )}
                            onClick={onAddAfter}
                        />
                    </Tooltip>
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__( "Remove" )}</div>}
                    >
                        <Button
                            className="edit-menu-btn danger"
                            icon="trash" 
                            intent={ Intent.DANGER }
                            size={ Size.SMALL }
                            //text={__("Remove")}
                            onClick={onRemove}
                        />   
                    </Tooltip>          
                    {/* <Popover
                        position="bottom-left"
                        interactionKind="hover"
                        content={
                            <ButtonGroup vertical alignText="left">
                                <Button
                                    className="edit-menu-btn"
                                    icon={ !props.row.isHidden ? "eye-open" : "eye-off"}
                                    size={ Size.SMALL }
                                    text={__( props.row.isHidden ? "Do show" : "Do hide" )}
                                    onClick={onVisible}
                                />
                                <Button
                                    className="edit-menu-btn"
                                    icon={ "plus" }
                                    size={ Size.SMALL }
                                    text={__( "Add after" )}
                                    onClick={onAddAfter}
                                />
                                <Button
                                    className="edit-menu-btn danger"
                                    icon="trash" 
                                    intent={ Intent.DANGER }
                                    size={ Size.SMALL }
                                    text={__("Remove")}
                                    onClick={onRemove}
                                />  
                            </ButtonGroup>
                        }
                    >
                        <Button
                            className="edit-menu-btn"
                            icon="caret-down"
                            size={ Size.SMALL }
                        />
                    </Popover> */}
                </ButtonGroup>
            </div>
        }
    </>
}
export default TableTrEditor